import React from "react";
import { RaisedButton, Popover, Menu, MenuItem } from "material-ui";
import qs from "qs";

import UserStore from "../../stores/UserStore";
import config from "../../config";

class ImportFilmsButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null
    };

    this._onClick = this._onClick.bind(this);
    this._onClose = this._onClose.bind(this);
  }

  _onClick(e) {
    e.preventDefault();

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  }

  _onClose() {
    this.setState({ open: false });
  }

  render() {
    let { style, label } = this.props;

    return (
      <div style={Object.assign({ display: "inline-block" }, style)}>
        <RaisedButton label={label} onTouchTap={this._onClick} />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onRequestClose={this._onClose}
        >
          <Menu desktop={true}>
            <MenuItem
              primaryText="Bulk import using a spreadsheet"
              onTouchTap={() => {
                this.props.onBulkImportClick();
              }}
            />
            <MenuItem
              primaryText="Clone from another event bucket"
              onTouchTap={() => {
                this._onClose();
                this.props.onCloneFilmsClick();
              }}
            />
            {(this.props.additionalOptions || []).map(option => {
              return (
                <MenuItem
                  key={option.label}
                  primaryText={option.label}
                  href={option.href}
                  target="_blank"
                />
              );
            })}
          </Menu>
        </Popover>
      </div>
    );
  }
}

export default ImportFilmsButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/import-films-button.jsx